<ng-container *ngIf="teamMember$ | async as teamMember">
    <app-team-member-info
        (submitTeamMember)="onSubmit($event)"
        [teamMember]="teamMember"
        [organizationList]="organizationList"
        [submittingAndAdding]="loading"
    >
    <ng-container title> Edit Team Member </ng-container>
    </app-team-member-info>
</ng-container>